<template>

  <el-cascader v-model="value" placeholder="请选择" :options="options" filterable tag-type="danger"
               :props="{emitPath:false}" @change="handleChange" :disabled="disable" style="width: 100%;">
  </el-cascader>

</template>

<script>
import {mapStores} from "pinia";
import {useEtlStore} from "@/stores/etl";

export default {
  emits:['change','update:modelValue'],
  props: {
    id:{
      type:String,
      default:null
    },
    modelValue: {
      type: String,
      default: () => ""
    },
    disable: {
      type: Boolean,
      default: null
    }
  },
  computed:{
    ...mapStores(useEtlStore)
  },
  data() {
    return {
      value: '',
      options: [],
    }
  },
  created() {
    if(this.modelValue){
      this.value = this.modelValue;
    }
    this.queryList();
  },
  methods:{
   async queryList(){

      this.options = []
      let res = await this.etlStore.list();
      let packages = res.data;
      let groups = new Set()

      packages.forEach(pack => {
        groups.add(pack.group)
      })

    groups.forEach(group=>{

      this.options.push({
        label: group,
        value: group,
        children: packages.filter(form => form.group === group).map(p => {
          return {
            label: p.name,
            value: p.id,
            disabled:false,
          }
        })
      })

    })
    },
    handleChange(){
      this.$emit("update:modelValue", this.value);
      this.$emit('change',this.value)
    }
  }


}

</script>

<style scoped lang="scss">

</style>